import { App } from 'vue'
// import { accessMeta } from '@/packages/vue-router-permissions'
import { route, prefixRoutes } from '@/router/utils'
import { RouteRecordRaw } from 'vue-router'
import { createRoutes as createProfileRoutes, PROFILE_PAGE_NAME } from './modules/profile/router'
import { createRoutes as createSellersRoutes } from './modules/sellers/router'
import { createRoutes as createBuyersRoutes } from './modules/buyers/router'
import { createRoutes as createOutletsRoutes } from './modules/outlets/router'
import { createRoutes as createRegistrationsRoutes } from './modules/registrations/router'
import { createRoutes as createMotivationsRoutes } from './modules/motivations/router'
import { createRoutes as createReportsRoutes } from './modules/reports/router'
import { createRoutes as createPaymentsRoutes } from './modules/payments/router'
import { createRoutes as createGoodsRemainingRoutes } from './modules/goods-remaining/router'
import { createRoutes as createPublicationsRoutes } from './modules/publications/router'
import { createRoutes as createAnalyticsRoutes } from './modules/analytics/router'
import { createRoutes as createPageNotFoundRoutes, NOT_FOUND_PAGE_NAME } from '../errors/404/router'
import { createRoutes as createAccessDeniedRoutes } from '../errors/403/router'


// import { allPermissions } from '@access/index'
// import { accessPermission, } from '@/permissions/permissions'
import { prefixLanguage } from '@utils/urls'
// import { checkPermissions } from "@/permissions/permissions";
// const textPage = () => import('./modules/text-page/text-page.vue')
const Cabinet = () => import('./views/Cabinet.vue')

// const {
//   STAFF: {
//     PROTOCOL: {
//       VIEW: VIEW_PROTOCOL,
//       SORT: SORT_PROTOCOL
//     },
//   },
// } = allPermissions

export const BASE_PAGE_NAME = 'cabinet:page'
export const BASE_PAGE_URL = prefixLanguage('/cabinet/')

const adminRole = '1'
const accountantRole = '2'

export function createRoutes(options): RouteRecordRaw[]  {
  return [
    route(BASE_PAGE_URL, Cabinet, BASE_PAGE_NAME, {
      children: [
        prefixRoutes('profile/', createProfileRoutes(options), { meta: { roles: [adminRole, accountantRole] } }),
        prefixRoutes('sellers/', createSellersRoutes(options), { meta: { roles: [adminRole] } }),
        prefixRoutes('buyers/', createBuyersRoutes(options), { meta: { roles: [adminRole] } }),
        prefixRoutes('outlets/', createOutletsRoutes(options), { meta: { roles: [adminRole] } }),
        prefixRoutes('registrations/', createRegistrationsRoutes(options), { meta: { roles: [adminRole] } }),
        prefixRoutes('motivations/', createMotivationsRoutes(options), { meta: { roles: [adminRole] } }),
        prefixRoutes('reports/', createReportsRoutes(options), { meta: { roles: [adminRole] } }),
        prefixRoutes('payments/', createPaymentsRoutes(options), { meta: { roles: [adminRole, accountantRole] } }),
        prefixRoutes('goods-remaining/', createGoodsRemainingRoutes(options), { meta: { roles: [adminRole] } }),
        prefixRoutes('publications/', createPublicationsRoutes(options), { meta: { roles: [adminRole] } }),
        prefixRoutes('analytics/', createAnalyticsRoutes(options), { meta: { roles: [adminRole] } }),
        // prefixRoutes('notifications/', createNotificationsRoutes(options),
        //   { meta: { ...accessPermission([VIEW_USER, ], options) } }
        // ),
        prefixRoutes('not-found/', createPageNotFoundRoutes(options)),
        prefixRoutes('access-denied/', createAccessDeniedRoutes(options)),
        {
          path: prefixLanguage('/cabinet/:pathMatch(.*)*'),
          redirect: { name: NOT_FOUND_PAGE_NAME }
        },
        // // route('info/:slug/', textPage, 'text-page', {}),
      ],
      redirect: { name: PROFILE_PAGE_NAME },
    }),
  ]
}
